import { RectNode, RectNodeModel, h } from '@logicflow/core';
import { renderMarkers } from './markers';
import { renderWrappedText } from './textUtils';
import { getThemeStyle } from '../theme';

class ReceiveTaskView extends RectNode {
  getShape() {
    const { model } = this.props;
    const { x, y, width, height, radius } = model;
    const style = model.getNodeStyle();
    const props = model.properties || {};

    // Envelope icon position (top-left corner)
    const ix = x - width / 2 + 8;
    const iy = y - height / 2 + 6;

    const children = [
      h('rect', {
        x: x - width / 2,
        y: y - height / 2,
        width,
        height,
        rx: radius,
        ry: radius,
        ...style,
      }),
      // BPMN Receive icon (open envelope outline)
      h('rect', {
        x: ix,
        y: iy + 2,
        width: 12,
        height: 10,
        fill: 'none',
        stroke: style.stroke,
        strokeWidth: 1.2,
      }),
      h('path', {
        d: `M ${ix} ${iy + 2} L ${ix + 6} ${iy + 7} L ${ix + 12} ${iy + 2}`,
        fill: 'none',
        stroke: style.stroke,
        strokeWidth: 1.2,
      }),
    ];

    const label = (props && props.name) || '';
    if (label) {
      children.push(renderWrappedText(h, label, x, y + 4, width - 20, { graphModel: model.graphModel }));
    }

    children.push(...renderMarkers(x, y, width, height, props, style.stroke));

    return h('g', {}, children);
  }
}

class ReceiveTaskModel extends RectNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.width = 120;
    this.height = 60;
    this.radius = 5;
    this.text = { ...this.text, editable: false, draggable: false, value: '' };
  }


  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'receiveTask');
    style.stroke = t.stroke || '#40a9ff';
    style.strokeWidth = t.strokeWidth ?? 1;
    style.fill = t.fill || '#e6f7ff';
    return style;
  }
}

export const ReceiveTask = {
  type: 'epx:ReceiveTask',
  view: ReceiveTaskView,
  model: ReceiveTaskModel,
};
